import Resource from './common/resource';

class FormCollections extends Resource {
  path = 'form/collections';
}

export default FormCollections;
